// extracted by mini-css-extract-plugin
export default {"testimonials":"Testimonials_testimonials__rlNl9","carousel":"Testimonials_carousel__KCyqQ","cards":"Testimonials_cards__OdvZK","scrollLeft":"Testimonials_scrollLeft__hXQvU"};